import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { fetchUserProfile } from './action';
import { dateSlashFormant, getLastMonthDate } from '../../shared/dateFunction';
import moment from 'moment';
import { onFetchOrder } from '../userOrders/action';
import { onFetchNotification } from '../notification/action';
import { onFetchDashboardData } from '../analytics/action';

const momentDate = moment();
const initialData = {
    search: null,
    filterBy: null,
    date: { from: getLastMonthDate(), to: dateSlashFormant(momentDate) },
    pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 999999,
        rowsNumber: 0,
    },
    status: 0,
};


const onlyForNotificationPayload = {
    search: null,
    filterBy: null,
    date: { from: null, to: null },
    pagination: {
        sortBy: 'id',
        descending: true,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 0,
    },
    status: 0,
};



export default function Index() {
    const dispatch = useDispatch();
    const products = useSelector((state) => state.UserProfile?.allData);
    const userOrdersData = useSelector((state) => state?.UserOrder);
    const notificationData = useSelector(state => state?.Notification?.allData);
    const analyticData = useSelector((state) => state?.Analytic?.allData);

    useEffect(() => {
        if (!products?.length) {
            dispatch(fetchUserProfile());
        }
    }, [dispatch, products?.length]);


    useEffect(() => {
        if (!userOrdersData?.length) {
            dispatch(onFetchOrder(initialData));
        }
    }, [dispatch, userOrdersData?.length]);


    useEffect(() => {
        if (!notificationData?.data?.length) {
            dispatch(onFetchNotification(onlyForNotificationPayload));
        }
    }, [dispatch, notificationData?.data?.length]);


    useEffect(() => {
        if (!analyticData?.status) {
            dispatch(onFetchDashboardData());
        }
    }, [dispatch, analyticData]);

    return null;
}